import useDodoableQuery from 'generated/api/dodoables/useDodoableQuery'
import HeaderContext from 'app/HeaderContext'
import StartNewButton from 'app/dodones/shared/StartNewButton'
import DodoableDodones from 'app/dodoables/Dodones'
import LoadingScreen from 'app/components/LoadingScreen'

export default ({ dodoableId }) => {
  const { setText } = useContext(HeaderContext)

  const { isPending, data: { dodoable } = {} } = useDodoableQuery({
    dodoableId
  })

  useEffect(() => {
    setText(dodoable?.name || 'Loading...')

    if (!dodoable) return
  }, [dodoable])

  if (isPending) return <LoadingScreen />
  if (!isPending && !dodoable) return <Navigate to={`/`} replace />

  return (
    <div className="p-2 m-2 fcol flex-1">
      <DodoableDodones dodoableId={dodoableId} />
      {dodoable.isFreeable && <StartNewButton dodoableId={dodoableId} />}
    </div>
  )
}
